import { render, staticRenderFns } from "./CommunityTableRow.vue?vue&type=template&id=29b64ee8&scoped=true&"
import script from "./CommunityTableRow.vue?vue&type=script&lang=js&"
export * from "./CommunityTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b64ee8",
  null
  
)

export default component.exports